import React from "react";
import useDarkMode from "@/hooks/useDarkMode";
import { Link } from "react-router-dom";
import useWidth from "@/hooks/useWidth";

import MainLogo from "@/assets/images/logo/logo.svg";
import LogoWhite from "@/assets/images/logo/logo-white.png";
// import MobileLogo from "@/assets/images/logo/logo-c.svg";
import MobileLogo from "@/assets/images/logo/logo-c.png";
import MobileLogoWhite from "@/assets/images/logo/logo-c-white.png";
// import MobileLogoWhite from "@/assets/images/logo/logo-c-white.svg";
const Logo = () => {
  const [isDark] = useDarkMode();
  const { width, breakpoints } = useWidth();

  return (
    <div>
      <Link to="">
        {width >= breakpoints.xl ? (
          <img src={isDark ? LogoWhite : MainLogo} alt="" />
        ) : (
          <img src={isDark ? MobileLogoWhite : MobileLogo} alt="" width={40} />
        )}
      </Link>
    </div>
  );
};

export default Logo;
